import classNames from 'classnames';
import Page from '../../components/Layout/Page';
import { getPageContent } from '../../api/pagesApi';
import { genShareConfig } from '../../components/Share/use-config-share';
import { serverSideTranslation } from '../../util/next';
import NewsGroup from '../../components/NewsGroup';
import styles from './Algorithm.module.scss';
import { Decoration } from '../../modules/HomeBanner/Decoration';

const homeMoImg = 'https://p0.meituan.net/smartvenus/226d7534be373471a80440202a20cc2264014.png';
const homeCenterPcImg = 'https://s3plus.meituan.net/smart/halfbg2.svg';
const homeCenterPcHoverImg = 'https://s3plus.meituan.net/smart/pc-bg.svg';
const homeLeftImg = 'https://s3plus.meituan.net/smart/left-trans.svg';
const homeRightImg = 'https://s3plus.meituan.net/smart/right2.svg';

const FoodSafety = (props: any) => {
  const { _nextI18Next: i18n, pageContentData } = props;
  const { shareContent = {}, pageContent = {} } = pageContentData || {};
  const description =
    shareContent.shareDetail || '美团持续推进食品安全治理，不断完善相关措施，努力为大家提供更安全、更放心的消费环境。';
  const title = shareContent.shareTitle || '食品安全';
  const { pageTitle, groupDataList } = pageContent;

  return (
    <Page description={description} title={title}>
      <div className="w-full bg-[#f7f8f9]">
        <section
          className={classNames(styles['newsroom-banner-box'], 'pt-15 xl:pt-20')}
          style={
            {
              '--auto-bg': `url(${homeMoImg})`,
              '--1024-bg': `url(${homeCenterPcImg})`,
              '--1024-hover-bg': `url(${homeCenterPcHoverImg})`,
            } as any
          }
        >
          <h1 className="mt-font mx-auto w-[303px] pt-[70px] text-center text-[24px] font-normal leading-[38px] text-[#111111] md:w-[908px] md:pt-[104px] md:text-[36px] md:leading-[56px]">
            {pageTitle || description}
          </h1>
          <Decoration className={styles.newsroomBannerLeft} lg={homeLeftImg} xl={homeLeftImg} />
          <Decoration className={styles.newsroomBannerRight} lg={homeRightImg} xl={homeRightImg} />
        </section>
        <div className="bg-white-homebg pb-[60px] pt-[50px] md:pb-[90px] md:pt-[68px]">
          {groupDataList?.map((item: any, index: number) => {
            return <NewsGroup key={index} lanType={i18n.initialLocale} {...item} />;
          })}
        </div>
      </div>
    </Page>
  );
};

export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/newsroom/food-safety',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_5cfgosy3',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      ...genShareConfig(pageContentData),
      ...(await serverSideTranslation(locale, ['contactus', 'cookie', 'common'])),
    },
  };
}

export default FoodSafety;
